/**
 * Supplier Services Module
 * Exports all supplier management services and factory functions
 */
// Service exports
export * from './SupplierService';
export * from './IndustryService';
export * from './SupplierContactService';
export * from './SupplierNoteService';
export * from './SupplierAccountService';
export * from './SubscriptionUserService';
export * from './SupplierSubscriptionService';
export * from './SubscriptionStatusService';
export * from './SubscriptionTypeService';
// Service imports for factory
import { SupplierService } from './SupplierService';
import { IndustryService } from './IndustryService';
import { SupplierContactService } from './SupplierContactService';
import { SupplierNoteService } from './SupplierNoteService';
import { SupplierAccountService } from './SupplierAccountService';
import { SubscriptionUserService } from './SubscriptionUserService';
import { SupplierSubscriptionService } from './SupplierSubscriptionService';
import { SubscriptionStatusService } from './SubscriptionStatusService';
import { SubscriptionTypeService } from './SubscriptionTypeService';
/**
 * Create all supplier services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all supplier service instances
 */
export function createSupplierServices(http, config) {
    return {
        supplier: new SupplierService(http, config),
        industry: new IndustryService(http, config),
        supplierContact: new SupplierContactService(http, config),
        supplierNote: new SupplierNoteService(http, config),
        supplierAccount: new SupplierAccountService(http, config),
        subscriptionUser: new SubscriptionUserService(http, config),
        supplierSubscription: new SupplierSubscriptionService(http, config),
        subscriptionStatus: new SubscriptionStatusService(http, config),
        subscriptionType: new SubscriptionTypeService(http, config),
    };
}
//# sourceMappingURL=index.js.map